import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslatePaginatorService extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();
    this.translateLabels();
  }

  translateLabels() {
    this.translate
      .get([
        'paginator.itemsPerPage',
        'paginator.nextPage',
        'paginator.previousPage',
        'paginator.firstPage',
        'paginator.lastPage',
      ])
      .subscribe((res: string) => {
        this.itemsPerPageLabel = res['paginator.itemsPerPage'];
        this.nextPageLabel = res['paginator.nextPage'];
        this.previousPageLabel = res['paginator.previousPage'];
        this.firstPageLabel = res['paginator.firstPage'];
        this.lastPageLabel = res['paginator.lastPage'];
        this.changes.next();
      });
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    const of = this.translate ? this.translate.instant('paginator.of') : 'of';
    if (length === 0 || pageSize === 0) {
      return '0 ' + of + ' ' + length;
    }
    length = Math.max(length, 0);
    const startIndex =
      page * pageSize > length
        ? (Math.ceil(length / pageSize) - 1) * pageSize
        : page * pageSize;

    const endIndex = Math.min(startIndex + pageSize, length);
    return startIndex + 1 + ' - ' + endIndex + ' ' + of + ' ' + length;
  }
}
